import { FormattedMessage } from "react-intl";
import eventEmpty from "@/assets/event_empty.svg";
import { EraserIcon, PlusIcon } from "@/icons";
import { Link } from "@/kit/ui/link";
import { Button } from "@/kit/ui/button";

interface Props {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  hasFilters: boolean;
  createEventPath: string;
}

export function EventsEmpty({
  onClick,
  hasFilters,
  createEventPath,
}: Readonly<Props>) {
  return hasFilters ? (
    <div className="flex flex-col items-center gap-6">
      <img src={eventEmpty} />
      <div className="flex flex-col items-center gap-1 w-80">
        <p className="text-grey-900 text-lg font-semibold">
          <FormattedMessage defaultMessage="No matching results found" />
        </p>
        <p className="text-grey-600 text-sm font-normal text-center">
          <FormattedMessage defaultMessage="Try searching something else or adjust filters" />
        </p>
      </div>
      <Button variant="secondary" onClick={onClick}>
        <EraserIcon className="w-5 h-5" />
        <FormattedMessage defaultMessage="Clear search & filters" />
      </Button>
    </div>
  ) : (
    <div className="flex flex-col items-center gap-6">
      <img src={eventEmpty} />
      <div className="flex flex-col items-center gap-1 w-80">
        <p className="text-grey-900 text-lg font-semibold">
          <FormattedMessage defaultMessage="No challenges yet" />
        </p>
        <p className="text-grey-600 text-sm font-normal text-center">
          <FormattedMessage defaultMessage="Create the first one to kick things off." />
        </p>
      </div>

      <Link variant="primary" to={createEventPath}>
        <PlusIcon className="w-5 h-5" />
        <FormattedMessage defaultMessage="Create challenge" />
      </Link>
    </div>
  );
}
